import React, { memo } from 'react';
import { Handle, Position } from '@xyflow/react';
import { Flag, CheckCircle2 } from 'lucide-react';

// Tailwind colour presets keyed by the workflow state `color` field.
const COLOR_MAP = {
  green: 'border-green-500 bg-green-50',
  amber: 'border-amber-500 bg-amber-50',
  yellow: 'border-yellow-500 bg-yellow-50',
  red: 'border-red-500 bg-red-50',
  blue: 'border-blue-500 bg-blue-50',
  orange: 'border-orange-500 bg-orange-50',
  gray: 'border-gray-400 bg-gray-50',
  grey: 'border-gray-400 bg-gray-50',
};

export const stateNodeColor = (color) => COLOR_MAP[color] || 'border-stone-400 bg-white';

const StateNode = memo(({ data, selected }) => {
  const colorCls = stateNodeColor(data.color);
  return (
    <div
      data-testid={`wf-node-${data.code || 'new'}`}
      className={`rounded-lg border-2 px-4 py-2 min-w-[150px] shadow-sm transition-all ${colorCls} ${
        selected ? 'ring-2 ring-orange-500 ring-offset-1' : ''
      }`}
    >
      <Handle type="target" position={Position.Left} className="!bg-stone-500 !w-3 !h-3" />
      <div className="flex items-center gap-1.5">
        {data.is_initial && <Flag className="w-3.5 h-3.5 text-green-600" title="Initial state" />}
        {data.is_terminal && <CheckCircle2 className="w-3.5 h-3.5 text-stone-600" title="Terminal state" />}
        <span className="font-semibold text-sm text-stone-800 truncate">
          {data.label || 'Untitled'}
        </span>
      </div>
      <div className="font-mono text-[11px] text-stone-500 mt-0.5">{data.code || '—'}</div>
      <Handle type="source" position={Position.Right} className="!bg-orange-500 !w-3 !h-3" />
    </div>
  );
});

StateNode.displayName = 'StateNode';

export default StateNode;
